import { SortAscending } from "@phosphor-icons/react";

import { Menu, MenuButton, MenuList } from "../Menu";
import type { PackSort } from "./PackSort";
import { PackSortLabel } from "./PackSortLabel";

export const PackSortMenu: React.FC<{
  sort: PackSort;
  children: React.ReactElement;
}> = ({ sort, children }) => {
  return (
    <Menu>
      <MenuButton className="btn btn-outline max-md:btn-sm">
        <SortAscending className="size-5" weight="bold" />
        <PackSortLabel sort={sort} />
      </MenuButton>
      <MenuList>{children}</MenuList>
    </Menu>
  );
};
